/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Watching_CountInputs */

const th_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`กำลังดู ${i?.count} คน`)
};

const en_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} watching`)
};

const ja_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}人が視聴中`)
};

const zh_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人在看`)
};

const es_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} viendo`)
};

const pt_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} assistindo`)
};

const id_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} menonton`)
};

const fr_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} spectateurs`)
};

const tl_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ang nanonood`)
};

const vi_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} người đang xem`)
};

const ko_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}명 시청 중`)
};

const de_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} schauen zu`)
};

const ru_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Смотрят: ${i?.count}`)
};

const tr_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kişi izliyor`)
};

const it_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} spettatori`)
};

const pl_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oglądających: ${i?.count}`)
};

const uk_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дивляться: ${i?.count}`)
};

const hi_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} देख रहे हैं`)
};

const ar_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} يشاهدون`)
};

const ms_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sedang menonton`)
};

const bn_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} জন দেখছেন`)
};

const zh_tw2_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人觀看中`)
};

const zh_hk2_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人觀看中`)
};

const ur_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} دیکھ رہے ہیں`)
};

const fa_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} نفر تماشا می‌کنند`)
};

const sw_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wanatazama`)
};

const nl_watching_count = /** @type {(inputs: Watching_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kijken mee`)
};

/**
* | output |
* | --- |
* | "{count} watching" |
*
* @param {Watching_CountInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const watching_count = /** @type {((inputs: Watching_CountInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Watching_CountInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_watching_count(inputs)
	if (locale === "ja") return ja_watching_count(inputs)
	if (locale === "zh") return zh_watching_count(inputs)
	if (locale === "es") return es_watching_count(inputs)
	if (locale === "pt") return pt_watching_count(inputs)
	if (locale === "id") return id_watching_count(inputs)
	if (locale === "fr") return fr_watching_count(inputs)
	if (locale === "tl") return tl_watching_count(inputs)
	if (locale === "vi") return vi_watching_count(inputs)
	if (locale === "ko") return ko_watching_count(inputs)
	if (locale === "de") return de_watching_count(inputs)
	if (locale === "ru") return ru_watching_count(inputs)
	if (locale === "tr") return tr_watching_count(inputs)
	if (locale === "it") return it_watching_count(inputs)
	if (locale === "pl") return pl_watching_count(inputs)
	if (locale === "uk") return uk_watching_count(inputs)
	if (locale === "hi") return hi_watching_count(inputs)
	if (locale === "ar") return ar_watching_count(inputs)
	if (locale === "ms") return ms_watching_count(inputs)
	if (locale === "bn") return bn_watching_count(inputs)
	if (locale === "zh-TW") return zh_tw2_watching_count(inputs)
	if (locale === "zh-HK") return zh_hk2_watching_count(inputs)
	if (locale === "ur") return ur_watching_count(inputs)
	if (locale === "fa") return fa_watching_count(inputs)
	if (locale === "sw") return sw_watching_count(inputs)
	if (locale === "nl") return nl_watching_count(inputs)
	return en_watching_count(inputs)
});